import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import {
  getTermsAndConditions,
  acceptTermsAndConditions,
} from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { AcceptTermsPayload, TermsAndConditionsResponse } from "./types";
import providerOnboardingQueryKeys from "./query-keys";

export const useTermsAndConditions = (
  userId: string,
  applicationId: string,
  providerType: string,
  options?: Omit<UseQueryOptions<TermsAndConditionsResponse, Error>, "queryKey" | "queryFn">
) => {
  return useQuery<TermsAndConditionsResponse, Error>({
    queryKey: providerOnboardingQueryKeys.termsAndConditions(userId, applicationId, providerType),
    queryFn: () => getTermsAndConditions(userId, applicationId, providerType),
    enabled: !!userId && !!applicationId && !!providerType,
    staleTime: Infinity,
    ...options,
  });
};

interface AcceptTermsParams {
  userId: string;
  applicationId: string;
  providerType: string;
  payload: AcceptTermsPayload;
}

export const useAcceptTermsAndConditions = (
  options?: UseMutationOptions<unknown, Error, AcceptTermsParams>
) => {
  return useMutation<unknown, Error, AcceptTermsParams>({
    mutationFn: ({ userId, applicationId, providerType, payload }) =>
      acceptTermsAndConditions(userId, applicationId, providerType, payload),
    ...options,
  });
};
